import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DxButtonComponent,
    DxDataGridComponent,
    DxFormComponent,
    DxTemplateDirective,
} from 'devextreme-angular';
import {
    DxiButtonComponent,
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent,
} from 'devextreme-angular/ui/nested';
import { CarrierStatus, CarrierGridViewDto, AuthService, PermissionType, AccessType } from '@services';
import { NgClass } from '@angular/common';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import EnumUtils from '../../../shared/enum-utils';
import { AddCarrierFormComponent } from './add-carrier-form/add-carrier-form.component';
import { EditCarrierFormComponent } from './edit-carrier-form/edit-carrier-form.component';
import { FilterPanelComponent } from '../../../components/library/filter-panel/filter-panel.component';
import { PhoneFormatPipe } from 'src/app/pipes/phone-format.pipe';
import { CapitalCasePipe } from '../../../pipes/capital-case.pipe';
import {
    FilterConfig,
    GridPageComponent,
} from '../../common/grid-page.component';
import { UserAvatarEmailComponent } from 'src/app/components/utils/user-avatar-email/user-avatar-email.component';
import { DATE_TIME_FORMAT } from 'src/app/shared/constants';

@Component({
    selector: 'app-carriers',
    imports: [
        CommonModule,
        CapitalCasePipe,
        DxDataGridComponent,
        DxiColumnComponent,
        DxoHeaderFilterComponent,
        DxoScrollingComponent,
        DxButtonComponent,
        DxTemplateDirective,
        DxiItemComponent,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoLoadPanelComponent,
        DxoSortingComponent,
        DxoToolbarComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoFilterRowComponent,
        DxFormComponent,
        FilterPanelComponent,
        AddCarrierFormComponent,
        EditCarrierFormComponent,
        DxiButtonComponent,
        DxoPositionComponent,
        DxoSearchComponent,
        DxoSelectionComponent,
        PhoneFormatPipe,
        NgClass,
        UserAvatarEmailComponent,
    ],
    templateUrl: './carriers.component.html',
})
export class CarriersComponent extends GridPageComponent<CarrierGridViewDto> {
    private authService = inject(AuthService);
    protected override exportName: string = 'Carriers';
    protected offset: number = 100;
    public dateTimeFormat = DATE_TIME_FORMAT;

    isAddCarrierPopupOpened = false;
    isEditCarrierPopupOpened = false;
    carrierId: string;
    dataSource = this.dataSources.carriers();
    carrierStatusOptions = EnumUtils.getEnumOptions(CarrierStatus);

    lastModifiedByFilter = this.userNameOrEmailFilter('lastModifiedBy');
    createdByFilter = this.userNameOrEmailFilter('createdBy');

    protected override filterConfig: FilterConfig[] = [
        { field: 'number', op: 'contains' },
        { field: 'name', op: 'contains' },
        { field: 'address', op: 'contains' },
        { field: 'scac', op: 'contains' },
        { field: 'phone', op: 'contains' },
        { field: 'email', op: 'contains' },
        { field: 'status', op: '=' },
        {field: 'lastModifiedBy.name', op: 'contains', customFilter: this.lastModifiedByFilter},
        {field: 'lastModified', op: '>='},
        {field: 'createdBy.name', op: 'contains', customFilter: this.createdByFilter},
        {field: 'created', op: '>='},
    ];

    constructor() {
        super();
        this.init(CarrierGridViewDto);
    }

    protected getBadgeClass(status: CarrierStatus): string {
        switch (status) {
            case CarrierStatus.Inactive:
                return 'bg-secondary-subtle text-secondary';
            case CarrierStatus.Active:
                return 'bg-success-subtle text-success';
            default:
                return 'bg-info-subtle text-info';
        }
    }

    addCarrier() {
        this.isAddCarrierPopupOpened = true;
    }

    override onRowDblClick(e: DxDataGridTypes.RowDblClickEvent) {
        const { data } = e;

        this.carrierId = data.id;
        this.isEditCarrierPopupOpened = true;
    }

    protected async onSave() {
        await this.dataGrid.instance.refresh();
    }

    protected onDelete = ($event: any) => {
        this.dataGrid.instance.deleteRow($event.row.dataIndex);
    };

    override onEdit = (e: any) => {
        this.carrierId = e.row.data.id;
        this.isEditCarrierPopupOpened = true;
    };

    get canManage() {
        return this.authService.checkPermission(PermissionType.Carriers, AccessType.Manage);
    }
}
